import { Tabs as MuiTabs, Tab } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Label from 'src/legacy/components/label';
import { useLocales } from 'src/legacy/locales';
import { useSelector } from 'src/legacy/redux/store';
import { PATH_DASHBOARD } from 'src/legacy/routes/paths';

import { useFosterFamilyListNavigatorContext } from './FosterFamilyListNavigatorContext';

export const Tabs = () => {
  const navigate = useNavigate();

  const { translate } = useLocales();

  const { fosterFamilies } = useSelector((state) => state.fosterFamily);

  const { currentTab, tabs } = useFosterFamilyListNavigatorContext();

  const getCountRowsByStatus = (status: string) => {
    if (fosterFamilies) {
      return status === 'all'
        ? fosterFamilies.length
        : fosterFamilies.filter((family) => family.status === status).length;
    }
    return 0;
  };

  return (
    <MuiTabs
      onChange={(_, newValue) => {
        navigate(`${PATH_DASHBOARD.fosterFamily.list}/${newValue}`);
      }}
      sx={{
        bgcolor: '#F9FAFB',
        px: 2,
      }}
      value={currentTab}
    >
      {tabs.map((tab) => (
        <Tab
          icon={
            <Label color={tab.color} sx={{ mr: 1 }}>
              {getCountRowsByStatus(tab.value)}
            </Label>
          }
          key={tab.value}
          label={`${translate(tab.label)}`}
          value={tab.value}
        />
      ))}
    </MuiTabs>
  );
};
